export enum SortBy {
  NEWEST = 'newest',
  SIZE = 'size',
  NAME = 'name'
}
